module.exports = __webpack_public_path__ + "img/icone.3910493a.png";